// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1UKS3","approved":"Status_approved__2xAr3","rejected":"Status_rejected__3tA_C","expired":"Status_expired__2zPBZ","label":"Status_label__3NYVB"};